import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LangProvider } from './i18n';
import { SettingsProvider } from './settings';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <SettingsProvider>
      <LangProvider>
        <App />
      </LangProvider>
    </SettingsProvider>
  // </React.StrictMode>
);
